import { datatype, filterDetail, filtertype } from 'API';
import { ACdetails } from 'context/CampaignContext';

export const getQueryFilters = (activeCampaign: ACdetails, customReportCampaigns?: string[]) => {
  const removeNullValues = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(removeNullValues);
    } else if (obj !== null && typeof obj === 'object') {
      delete obj.__typename;
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v !== null)
          .map(([k, v]) => [k, removeNullValues(v)]),
      );
    } else {
      return obj;
    }
  };

  if (activeCampaign?.campaignId.toString().startsWith('100')) {
    const filters: filterDetail[] = [
      {
        column: 'campaign_id',
        filter: {
          filtertype: filtertype.IN,
          datatype: datatype.NUMBER,
          list: activeCampaign.childCampaigns?.map((e) => e?.campaignId.toString() as string),
        },
      },
    ];
    return filters;
  } else if (activeCampaign?.campaignId.toString().startsWith('200')) {
    const activeCustomReport = activeCampaign.campaignPeriods?.find((element) => element?.isActive === true);

    if (activeCustomReport) {
      if (activeCustomReport.CampaignID) {
        const campaignFilter: filterDetail = {
          column: 'campaign_id',
          filter: {
            filtertype: filtertype.EQUAL,
            datatype: datatype.NUMBER,
            value: activeCustomReport.CampaignID.toString(),
          },
        };
        const otherFilters = activeCustomReport.Filters;
        const transformedFilters = otherFilters?.map((filter) => {
          return {
            column: filter?.column as string,
            filter: {
              filtertype: filtertype[filter?.filter?.filtertype as keyof typeof filtertype],
              datatype: datatype[filter?.filter?.datatype as keyof typeof datatype],
              ...removeNullValues(filter?.filter),
            },
          };
        });
        const joinedFilters = [campaignFilter, ...(transformedFilters as filterDetail[])];
        return joinedFilters;
      } else {
        const filters: filterDetail[] = activeCustomReport.Filters as filterDetail[];
        return filters;
      }
    } else {
      if (customReportCampaigns) {
        if (customReportCampaigns.length > 1) {
          const filters: filterDetail[] = [
            {
              column: 'campaign_id',
              filter: {
                filtertype: filtertype.IN,
                datatype: datatype.NUMBER,
                list: customReportCampaigns,
              },
            },
          ];
          return filters;
        } else {
          const filters: filterDetail[] = [
            {
              column: 'campaign_id',
              filter: {
                filtertype: filtertype.EQUAL,
                datatype: datatype.NUMBER,
                value: customReportCampaigns[0],
              },
            },
          ];
          return filters;
        }
      }
    }
  } else {
    const filters: filterDetail[] = [
      {
        column: 'campaign_id',
        filter: {
          filtertype: filtertype.EQUAL,
          datatype: datatype.NUMBER,
          value: activeCampaign?.campaignId?.toString(),
        },
      },
    ];
    return filters;
  }

  //   return filters as filterDetail[];
};
